
export const getPageIdFromSlug = (slug) => {
  return slug.split("/")
    .filter((text) => text !== "")
    .pop()
}